import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FormLS_UB_1 from "../../Forms/FormLS_UB_1";
import Footer from "../../Includes/Layouts/LS_UB_1/Footer";
import FbViewPixel from "../../../Utility/FbViewPixel";
import "../../../assets/LS_UB_1/css/LS_UB_1.scss";
import Header from "../../Includes/Layouts/LS_UB_1/Header";
import Section1 from "../../Includes/Layouts/LS_UB_1/Section1";
import AccordSection from "../../Includes/Layouts/LS_UB_1/AccordSection";

const LS_UB_1 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="LS_UB_1" />
      <FbViewPixel />
      <div className="LS_UB_1">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormLS_UB_1 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default LS_UB_1;